import { getSolarRecommand } from '@/service/solar-calculator';
import { ItfProductAPI, ItfProductAPIResponse, ItfProductParamId } from './type';

const getAsynItem = async (productId: string, variantId: string, locale: string): Promise<ItfProductAPI> => {
    return await new Promise(async (resolve, reject) => {
        try {
            const res: ItfProductAPIResponse = await getSolarRecommand({ productId, variantId }, locale);
            if (res?.code === '0') {
                if (Object.keys(res?.data)?.length === 0) {
                    console.warn(`警告⚠️: 产品ID[ ${productId} ], 变体ID[ ${variantId} ] 的API接口请求返回数据为空, 请检查产品状态～！`);
                }
                return resolve((res?.data as ItfProductAPI) || ({} as ItfProductAPI));
            } else {
                console.error(res?.message);
                return reject(res?.message);
            }
        } catch (e) {
            console.error(e);
            return reject(e);
        }
    });
};

export const getItems = async (data: ItfProductParamId[], locale: string) => {
    const promises = data?.map((item: ItfProductParamId) => getAsynItem(item.productId, item.variantId, locale));
    const res: ItfProductAPI[] = await Promise.all(promises);
    return res;
};
